import script from "./CostEfficiencyAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./CostEfficiencyAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./CostEfficiencyAnalysis.vue?vue&type=style&index=0&id=bccff2d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bccff2d8"]])

export default __exports__